<div class="flex flex-col" *ngIf="!isLoading">
	<div class="icon-img flex justify-center">
		<svg width="162" height="155" viewBox="0 0 162 155" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M139.646 59.9234C139.646 73.4863 135.111 86.0628 127.513 96.1733C123.346 101.598 118.321 106.407 112.561 110.106C103.247 116.271 92.0939 119.847 80.0834 119.847C47.1157 119.847 20.3984 92.9675 20.3984 59.9234C20.3984 26.7559 47.1157 0 79.9608 0C91.9713 0 103.124 3.57567 112.438 9.61733C118.198 13.3163 123.223 18.125 127.39 23.5501C135.111 33.6607 139.646 46.2372 139.646 59.9234Z"
				fill="#DADFE9"/>
			<g filter="url(#filter0_d_13176_225436)">
				<path
					d="M139.436 100.064C139.436 111.732 130 121.168 118.231 121.168C118.028 121.168 116.303 121.168 103.62 121.168C94.793 121.168 80.6898 121.168 58.1653 121.168H47.4104C33.3072 121.472 22.0449 110.21 22.0449 96.6143C22.0449 82.917 33.4086 71.5533 47.7147 72.2635C59.9916 33.911 116.201 39.2884 120.97 78.96C131.522 80.279 139.436 89.2076 139.436 100.064Z"
					fill="url(#paint0_linear_13176_225436)"/>
			</g>
			<path
				d="M118.231 121.169C129.899 121.169 139.436 111.733 139.436 100.065C139.436 88.3965 129.899 78.9606 118.231 78.9606C106.563 78.9606 97.0254 88.3965 97.0254 100.065C97.0254 111.733 106.563 121.169 118.231 121.169Z"
				fill="url(#paint1_linear_13176_225436)"/>
			<path
				d="M83.6324 121.372C104.432 121.372 121.376 104.529 121.376 83.7293C121.376 62.9296 104.432 46.087 83.6324 46.087C62.8328 46.087 45.8887 62.9296 45.8887 83.7293C45.8887 104.529 62.7313 121.372 83.6324 121.372Z"
				fill="url(#paint2_linear_13176_225436)"/>
			<g filter="url(#filter1_d_13176_225436)">
				<path
					d="M109.676 20.2295L109.496 98.7254C109.49 100.558 108.386 102.15 106.734 102.827C90.464 109.23 72.5024 109.284 56.2707 102.979C54.6232 102.312 53.5283 100.727 53.5338 98.8945L53.6536 20.3377C53.6591 18.5049 54.7636 16.9131 56.4152 16.2361C72.7462 9.89414 90.7078 9.83988 106.94 16.1445C108.587 16.8116 109.682 18.3967 109.676 20.2295Z"
					fill="url(#paint3_linear_13176_225436)"/>
			</g>
			<path
				d="M109.676 20.2295L109.496 98.7254C109.49 100.558 108.386 102.15 106.734 102.827C90.464 109.23 72.5024 109.284 56.2707 102.979C54.6232 102.312 53.5283 100.727 53.5338 98.8945L53.6536 20.3377C53.6591 18.5049 54.7636 16.9131 56.4152 16.2361C72.7462 9.89414 90.7078 9.83988 106.94 16.1445C108.587 16.8116 109.682 18.3967 109.676 20.2295Z"
				fill="#4F5870"/>
			<path
				d="M79.6976 104.605C81.3202 106.227 83.949 106.229 85.5692 104.609C87.1894 102.989 87.1875 100.36 85.5649 98.7375C83.9423 97.1149 81.3135 97.113 79.6933 98.7332C78.0731 100.353 78.075 102.982 79.6976 104.605Z"
				fill="#373737"/>
			<path
				d="M101.128 95.2941L62.3335 95.3502C61.2338 95.3535 60.3202 94.4398 60.3235 93.3402L60.4309 22.0695C60.4343 20.9698 61.3534 20.0506 62.4531 20.0473L101.247 19.9912C102.347 19.9879 103.261 20.9015 103.257 22.0012L103.15 93.2719C103.147 94.3716 102.289 95.2295 101.128 95.2941Z"
				fill="white"/>
			<path
				d="M72.4185 78.8196L64.8942 78.8423C64.2012 78.8444 63.7076 78.3509 63.7097 77.6579L63.7247 72.7077C63.7268 72.0147 64.2233 71.5182 64.9163 71.5161L72.4406 71.4933C73.1336 71.4912 73.6272 71.9848 73.6251 72.6778L73.6101 77.628C73.5587 78.2717 73.0622 78.7682 72.4185 78.8196Z"
				fill="#F08922"/>
			<path
				d="M84.8443 78.7327L77.32 78.7554C76.627 78.7575 76.1334 78.264 76.1355 77.571L76.1505 72.6208C76.1526 71.9277 76.6491 71.4312 77.3421 71.4291L84.8664 71.4064C85.5594 71.4043 86.0529 71.8978 86.0509 72.5909L86.0359 77.5411C86.0338 78.2341 85.4876 78.7802 84.8443 78.7327Z"
				fill="#D4DAE9"/>
			<path
				d="M97.2193 78.6952L89.695 78.718C89.0019 78.72 88.5084 78.2265 88.5105 77.5335L88.5255 72.5833C88.5276 71.8903 89.0241 71.3938 89.7171 71.3917L97.2414 71.3689C97.9344 71.3668 98.4279 71.8604 98.4259 72.5534L98.4109 77.5036C98.4088 78.1966 97.9123 78.6931 97.2193 78.6952Z"
				fill="#D4DAE9"/>
			<path
				d="M72.3872 89.0171L64.863 89.0398C64.1699 89.0419 63.6764 88.5484 63.6785 87.8554L63.6934 82.9052C63.6955 82.2122 64.1921 81.7157 64.8851 81.7136L72.4094 81.6908C73.1024 81.6887 73.5959 82.1823 73.5938 82.8753L73.5789 87.8255C73.5274 88.4692 73.0309 88.9657 72.3872 89.0171Z"
				fill="#D4DAE9"/>
			<path
				d="M84.7642 88.9796L77.2399 89.0024C76.5469 89.0045 76.0534 88.5109 76.0554 87.8179L76.0704 82.8677C76.0725 82.1747 76.569 81.6782 77.262 81.6761L84.7863 81.6534C85.4793 81.6513 85.9729 82.1448 85.9708 82.8378L85.9558 87.788C86.0034 88.4314 85.4572 88.9775 84.7642 88.9796Z"
				fill="#D4DAE9"/>
			<path
				d="M97.2388 88.9419L89.7145 88.9647C89.0215 88.9667 88.528 88.4732 88.53 87.7802L88.545 82.83C88.5471 82.137 89.0436 81.6405 89.7366 81.6384L97.2609 81.6156C97.954 81.6135 98.4475 82.1071 98.4454 82.8001L98.4304 87.7503C98.379 88.394 97.8825 88.8905 97.2388 88.9419Z"
				fill="#D4DAE9"/>
			<path
				d="M70.5694 35.6423C70.8743 35.8246 70.9341 36.2521 70.689 36.4972L69.3401 38.0897L69.401 38.1506L71.3571 37.7782C71.6628 37.7161 72.0286 37.9594 72.0275 38.326L72.0268 38.5703C72.0257 38.9369 71.6584 39.1824 71.3531 39.1222L69.3992 38.7616L69.3379 38.8228L70.6776 40.285C70.9212 40.5287 70.8588 40.9565 70.5528 41.1407L70.2468 41.3249C69.9407 41.5091 69.5745 41.388 69.4535 41.0218L68.7262 39.0691L68.0485 40.965C67.9252 41.3319 67.5583 41.4552 67.2534 41.2729L67.0093 41.1514C66.7044 40.9691 66.6446 40.5416 66.8897 40.2965L68.2386 38.704L66.2825 39.0764C65.9768 39.1385 65.611 38.8952 65.6121 38.5286L65.5516 38.3455C65.5527 37.979 65.92 37.7335 66.2253 37.7937L68.057 38.1547L66.7177 36.5703C66.4741 36.3267 66.5365 35.8988 66.8425 35.7146L67.1485 35.5304C67.4545 35.3462 67.8207 35.4673 67.9418 35.8335L68.6081 37.7254L69.2859 35.8294C69.4092 35.4625 69.7761 35.3392 70.081 35.5216L70.5694 35.6423Z"
				fill="#1C3754"/>
			<path
				d="M79.3061 35.6771C79.611 35.8594 79.6708 36.2869 79.4257 36.532L78.0768 38.1245L78.1377 38.1854L80.0938 37.8129C80.3995 37.7509 80.7653 37.9942 80.7642 38.3608L80.7635 38.6051C80.7624 38.9717 80.3951 39.2172 80.0898 39.157L78.1359 38.7964L78.0746 38.8576L79.4142 40.3198C79.6579 40.5635 79.5955 40.9913 79.2895 41.1755L78.9835 41.3597C78.6774 41.5439 78.3112 41.4228 78.1902 41.0566L77.4629 39.1039L76.7852 40.9998C76.6619 41.3667 76.295 41.49 75.99 41.3077L75.746 41.1862C75.4411 41.0039 75.3813 40.5764 75.6264 40.3313L76.9753 38.7388L75.0192 39.1112C74.7135 39.1733 74.3477 38.93 74.3488 38.5634L74.2274 38.3194C74.2285 37.9529 74.5958 37.7074 74.9011 37.7675L76.7328 38.1286L75.3935 36.5442C75.1499 36.3006 75.2122 35.8727 75.5183 35.6885L75.8243 35.5043C76.1303 35.3201 76.4965 35.4412 76.6176 35.8074L77.2839 37.6992L77.9616 35.8033C78.0849 35.4364 78.4519 35.3131 78.7568 35.4954L79.3061 35.6771Z"
				fill="#1C3754"/>
			<path
				d="M87.9811 35.6506C88.2861 35.8329 88.3459 36.2604 88.1007 36.5055L86.7519 38.098L86.8128 38.1589L88.7689 37.7865C89.1358 37.6632 89.4404 37.9677 89.4393 38.3343L89.4385 38.5787C89.4374 38.9452 89.131 39.2516 88.7648 39.1305L86.8109 38.7699L86.7497 38.8312L88.0893 40.2933C88.3329 40.537 88.2705 40.9648 87.9645 41.149L87.7198 41.2719C87.4138 41.4562 86.9867 41.2742 86.9265 40.9689L86.2602 39.077L85.5824 40.9729C85.4591 41.3399 85.0922 41.4632 84.7264 41.2199L84.4824 41.0985C84.1774 40.9161 84.1176 40.4886 84.3628 40.2435L85.6503 38.7123L83.633 39.146C83.3273 39.2081 82.9615 38.9648 82.9626 38.5982L82.9633 38.3538C82.9644 37.9873 83.2708 37.6809 83.637 37.802L85.4687 38.163L84.1904 36.6395C83.9467 36.3959 84.0091 35.9681 84.3151 35.7838L84.5599 35.6609C84.8659 35.4767 85.293 35.6587 85.3532 35.964L86.0195 37.8559L86.6972 35.9599C86.8205 35.593 87.1875 35.4697 87.4924 35.6521L87.9811 35.6506Z"
				fill="#1C3754"/>
			<path
				d="M96.8396 35.6851C97.0836 35.8066 97.2047 36.1728 96.9596 36.4179L95.5495 38.0717L95.6104 38.1326L97.6278 37.6988C97.9334 37.6368 98.1771 37.8805 98.2372 38.1857L98.2357 38.6745C98.235 38.9189 97.9286 39.2253 97.6233 39.1651L95.5472 38.8048L95.486 38.8661L96.8865 40.3892C97.1302 40.6328 97.0069 40.9997 96.7621 41.1227L96.2726 41.3685C96.0279 41.4915 95.6617 41.3704 95.5402 41.1264L94.813 39.1736L94.074 41.1308C93.9511 41.3755 93.645 41.5597 93.3401 41.3774L92.9743 41.1341C92.7303 41.0127 92.6705 40.5852 92.8543 40.4014L94.2645 38.7476L92.2471 39.1813C91.9414 39.2433 91.6978 38.9997 91.6376 38.6944L91.6391 38.2057C91.6402 37.8391 91.9462 37.6549 92.2515 37.7151L94.2054 38.0757L92.8052 36.4304C92.5616 36.1868 92.6849 35.8199 92.9296 35.6969L93.4191 35.4511C93.6639 35.3282 94.0301 35.4492 94.1515 35.6933L94.8787 37.646L95.6178 35.6888C95.7407 35.4441 96.0467 35.2599 96.3516 35.4422L96.8396 35.6851Z"
				fill="#1C3754"/>
			<defs>
				<filter id="filter0_d_13176_225436" x="0.0449219" y="35.1781" width="161.391" height="118.996"
						filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
					<feFlood flood-opacity="0" result="BackgroundImageFix"/>
					<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								   result="hardAlpha"/>
					<feOffset dy="11"/>
					<feGaussianBlur stdDeviation="11"/>
					<feColorMatrix type="matrix" values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"/>
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_13176_225436"/>
					<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_13176_225436" result="shape"/>
				</filter>
				<filter id="filter1_d_13176_225436" x="37.5332" y="6.44769" width="88.1426" height="128.221"
						filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
					<feFlood flood-opacity="0" result="BackgroundImageFix"/>
					<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
								   result="hardAlpha"/>
					<feOffset dy="11"/>
					<feGaussianBlur stdDeviation="8"/>
					<feColorMatrix type="matrix" values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.32 0"/>
					<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_13176_225436"/>
					<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_13176_225436" result="shape"/>
				</filter>
				<linearGradient id="paint0_linear_13176_225436" x1="80.7405" y1="77.1694" x2="80.7023" y2="121.983"
								gradientUnits="userSpaceOnUse">
					<stop stop-color="white"/>
					<stop offset="0.9964" stop-color="#ECF0F5"/>
				</linearGradient>
				<linearGradient id="paint1_linear_13176_225436" x1="94.7688" y1="74.4169" x2="113.567" y2="94.9768"
								gradientUnits="userSpaceOnUse">
					<stop stop-color="#BCCBE1"/>
					<stop offset="0.9942" stop-color="white" stop-opacity="0"/>
				</linearGradient>
				<linearGradient id="paint2_linear_13176_225436" x1="42.3543" y1="66.4562" x2="71.9824" y2="78.0506"
								gradientUnits="userSpaceOnUse">
					<stop stop-color="#E2E8F0"/>
					<stop offset="0.9942" stop-color="white" stop-opacity="0"/>
				</linearGradient>
				<linearGradient id="paint3_linear_13176_225436" x1="87.5826" y1="53.5236" x2="46.1493" y2="94.8459"
								gradientUnits="userSpaceOnUse">
					<stop stop-color="white"/>
					<stop offset="0.9964" stop-color="#ECF0F5"/>
				</linearGradient>
			</defs>
		</svg>

	</div>
	<ng-container>
		<ng-container>
			<div class="text-[24px] text-black font-bold m-t-16">
				Set your user PIN to secure your account.
			</div>
			<div class="mt-[12px] text-black text-[14px] font-medium">
				To improve security on your account, your user PIN will now be used to authorize transactions and carry out sensitive actions on your account.
			</div>
			<div class="mt-[12px] text-black text-[14px] font-medium">
				If you have POS terminals, your previous business PIN will now only be used to authorize POS transactions.
			</div>
		</ng-container>

		<ng-container *ngIf="!hideUseBusinessPin && isUserLoggedAsBo">
			<ng-container *ngIf="totalBusinesses===1 && userPinDetails?.hasBusinessPin && !isBusinessPinBlocked">
				<div class="text-[14px] text-primary font-bold m-t-16">
					<a class="cursor-pointer" (click)="updatePinToUse(1)">Use Business PIN as your User PIN</a>
				</div>
			</ng-container>
			<ng-container *ngIf="totalBusinesses>1 && !userPinDetails.isBusinessOwnerPinBlocked">
				<div class="text-[14px] text-primary font-bold m-t-16">
					<a class="cursor-pointer" (click)="updatePinToUse(2)">Use Business Owner PIN as your User PIN</a>
				</div>
			</ng-container>
		</ng-container>
	</ng-container>


</div>
<div nz-row class="mt-[16px]" nzJustify="space-between" *ngIf="!isLoading">
	<div nz-col nzSpan="24" *ngIf="!isUserBo && totalBusinesses===1 && userPinDetails?.hasBusinessPin && isBusinessPinBlocked;else defaultFlow">
		<div class="flex flex-row">
			<div class="w-full ">
				<app-custom-button
					[isBlock]="true"
					state="primary"
					text="Yes, Set User PIN" (click)="updatePinToUse(3)">
				</app-custom-button>
			</div>
		</div>
	</div>
	<ng-template #defaultFlow>
		<div nz-col nzSpan="24">
			<div class="flex flex-row">
				<div class="w-full pr-2" *ngIf="dismissible && selectedOption ===0">
					<ng-container>
						<app-custom-button
							[isBlock]="true"
							*ngIf="selectedOption===0"
							state="secondary"
							text="Do this Later" (click)="onBack()">
						</app-custom-button>
					</ng-container>
				</div>

				<div class="w-full"
					[class.pl-2]="dismissible"
				>

					<app-custom-button
						*ngIf="selectedOption===0"
						[isBlock]="true"
						state="primary"
						text="Setup User PIN" (click)="onSubmit()">
					</app-custom-button>
				</div>
			</div>
		</div>
	</ng-template>
</div>

<ng-container *ngIf="isLoading">
	<app-loading [loadingText]="'Please wait...'"></app-loading>
</ng-container>
